import { FolderHistory, IHistoryRepository } from "../../domain/history";
import { DownloadHistory } from "../../domain/history/DownloadHistory";
import { AuthenticatedRepository } from "../AuthenticatedRepository";
import { IDownloadHistoryBean, IFolderHistoryBean } from "./beans";
import { HistoryTranslator } from "./translators";

export class HistoryRepository extends AuthenticatedRepository implements IHistoryRepository {
  constructor(getToken: () => string) {
    super(getToken);
  }

  async getFolderHistories(): Promise<FolderHistory[]> {
    const url = "/api/folders/history";
    const result = await this.get(url);
    return this.toFolderHistories(result.data);
  }

  private toFolderHistories(beans: IFolderHistoryBean[]): FolderHistory[] {
    if (!beans) { return []; }
    return beans.map(b => HistoryTranslator.toFolderHistory(b));
  }

  async getDownloadHistories(folderGuid: string): Promise<DownloadHistory[]> {
    const url = "/api/folder/" + folderGuid + "/download-history";
    const result = await this.get(url);
    return this.toDownloadHistories(result.data);
  }

  private toDownloadHistories(beans: IDownloadHistoryBean[]): DownloadHistory[] {
    if (!beans) { return []; }
    return beans.map(b => HistoryTranslator.toDownloadHistory(b));
  }
}
